module.exports = __webpack_public_path__ + "img/mesa_l001i.2b44db8e.png";